export default "__VITE_ASSET__kow5t9D0__"